import { i as getBoxShadowFromTokens, j as boxShadow } from './borders-ef675321.esm.js';
import '@hover/tokens-size';
import '@hover/tokens-size/bauhaus';
import '@hover/tokens-size/next';
import '@hover/utilities';

var halos = ['primary', 'neutral', 'danger', 'warning', 'success'];
var rings = ['primary', 'neutral'];
var distance100 = /*#__PURE__*/getBoxShadowFromTokens({
  name: ['distance100A', 'distance100B', 'distance100C', 'distance100D']
});
var distance200 = /*#__PURE__*/getBoxShadowFromTokens({
  name: ['distance200A', 'distance200B', 'distance200C', 'distance200D', 'distance200E', 'distance200F']
});
var distance300 = /*#__PURE__*/getBoxShadowFromTokens({
  name: ['distance300A', 'distance300B', 'distance300C', 'distance300D', 'distance300E']
});
var distance400 = /*#__PURE__*/getBoxShadowFromTokens({
  name: ['distance400A', 'distance400B', 'distance400C', 'distance400D', 'distance400E', 'distance400F', 'distance400G', 'distance400H', 'distance400I']
});
var inset100 = /*#__PURE__*/getBoxShadowFromTokens({
  name: ['inset100A', 'inset100B', 'inset100C'],
  inset: true
});
var inset200 = /*#__PURE__*/getBoxShadowFromTokens({
  name: ['inset200A', 'inset200B', 'inset200C', 'inset200D', 'inset200E', 'inset200F'],
  inset: true
});
var shadows = {
  distance100: distance100,
  distance200: distance200,
  distance300: distance300,
  distance400: distance400,
  distance500: distance300,
  distance600: distance400,
  inset100: inset100,
  inset200: inset200
};
var ring = function ring(color) {
  return getBoxShadowFromTokens({
    name: 'ring',
    color: color
  });
};
var halo = function halo(color) {
  return getBoxShadowFromTokens({
    name: 'halo',
    color: color
  });
};
var invisible = function invisible(color) {
  return boxShadow('0', '0', '0', '0', color);
};

export { ring as a, halo as b, halos as h, invisible as i, rings as r, shadows as s };
